export default {
  scrollToTop() {
    window.scrollTo(0,0);
  },
}